import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import getLocale from '../../../i18n/getLocale';

class StaffCertificationsTab extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      staff_id: this.props.staff_id,
      name: null,
      type: null,
      only_active: 1,
      designacoes: 0,
      expiration: '',
      dispatch: '',
      staff_certifications: [],
      simple_list: [
        {value: 1, label: this.locale.general.sim},
        {value: 0, label: this.locale.general.nao},
      ],
      certifications_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.refreshSupplierSelect = this.refreshSupplierSelect.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.editFile = this.editFile.bind(this);
    // this.delete = this.delete.bind(this);
    this.exportGenerate = this.exportGenerate.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
  }
  
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChangeCertification(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //     this.setState(change, this.clearSupplierList());
  //   } else {
  //     change[name] = event.value;
  //     this.setState(change, this.refreshSupplierSelect(event.value));
  //   }
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_certifications)) {
      this.setState({
        staff_certifications: newProps.staff_certifications,
        certifications_list: newProps.certifications_list,
        loaded: 1
      });
    }
  }

  // clearSupplierList (name, event) {
  //   this.setState({ certification_suppliers_list: [] });
  // } 
  
  // // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     certification_id: this.state.certification_id,
  //     certification_supplier_id: this.state.certification_supplier_id,
  //     date_start: this.state.date_start,
  //     date_finish: this.state.date_finish,
  //     result: this.state.result,
  //     pf: this.state.pf,
  //     expire: this.state.expire,
  //     designacoes: this.state.designacoes,
  //     type: this.state.type,
  //     emissao: this.state.emissao,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.refreshData();
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  exportGenerate(event) {
    var self = this;
    var staff_certification_id = event;
    var url = '/exportar/certificado/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_certification_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  export(event) {
    var self = this;
    var staff_certification_id = event;
    var url = '/exportar/certificado/arquivo/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_certification_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/uploads/certifications/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  // Fetch ativando um item
  // ativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse certificado?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_certifications: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // editFile(staff_certification_id) {
  //   var confirm = window.confirm('Tem certeza que gostaria de adicionar/editar o arquivo desse certificado?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var data = new FormData();
  //     let input = '.input-sc-' + staff_certification_id;
  //     var import_data = document.querySelector(input).files[0];
  //     data.append("file", import_data);
  //     data.append("id", staff_certification_id);
  //     var header = this.refs.request_api.header();
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/certificado/editar/arquivo', { method: 'POST', mode: 'cors', headers: value, body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.refreshData();
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }  
  // // Fetch deletando um item
  // desativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse certificado?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/certificado/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_certifications: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  // refreshSupplierSelect (event) {
  //   this.props.handleAlert('', '', 'open');
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/certificado/fornecedores/lista/' + event, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       if (responseJson.status === 'success') {
  //         self.setState({certification_suppliers_list: responseJson.data});
  //       }
  //       if(typeof event.message !== 'undefined') {
  //         self.props.handleAlert(event.message, event.status, 'open');
  //       } else {
  //         self.props.handleAlert("", "", 'closed');
  //       }
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/certificados/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/certificados/ativos/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  // delete($staff_certification_id) {
  //   var confirm = window.confirm('Tem certeza que deseja deletar esse certificado?');
  //   if (confirm) {
  //     var self = this;
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/certificado/' + $staff_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tituloCertificados}</h3>
  <hr/>
  {(this.state.staff_certifications === null || typeof this.state.staff_certifications === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.nenhumCertificadoCadastrado}</em></small><hr/></div> 
  : 
  <div className="table-responsive">
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.ID}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Tipo}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Fim}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Vencimento}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Val}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Status}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Acoes}</th>
          {/* <th className="text-center">Arquivo</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_certifications).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_certifications[k].id}</td>
              <td className="text-center">{self.state.staff_certifications[k].certification}</td>
              <td className="text-center">{self.state.staff_certifications[k].date_finish_str}</td>
              <td className="text-center">{self.state.staff_certifications[k].expire_str}</td>
              <td className="text-center">
                {(self.state.staff_certifications[k].expire_status_str === 'Expirado') ?  
                  <label className="label label-sm label-danger">{self.state.staff_certifications[k].expire_status_str}</label>
                  :
                  <label className="label label-sm label-success">{self.state.staff_certifications[k].expire_status_str}</label>
                }
              </td>
              <td className="text-center">{(self.state.staff_certifications[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Arquivado}</span>}</td>
              <td className="text-center" style={{whiteSpace:"nowrap"}}>
                {/* {(self.state.staff_certifications[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_certifications[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_certifications[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                } */}
                {(self.state.staff_certifications[k].file !== null) ?  
                  <button className="btn btn-sm btn-warning" onClick={() => {self.export(self.state.staff_certifications[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                  : ''
                }
                <button className="btn btn-info btn-sm" onClick={() => {self.exportGenerate(self.state.staff_certifications[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                {/* <button className="btn btn-danger btn-sm" onClick={() => {self.delete(self.state.staff_certifications[k].id)}}><i className="fa fa-fw fa-trash"></i></button>
                <Link className={'btn btn-primary btn-sm'} to={'/staff_certifications/' + self.state.staff_id + "/" + self.state.staff_certifications[k].id}>
                  <i className="fa fa-fw fa-pencil"></i>
                </Link>   */}
              </td>
              {/* <td className="text-center" style={{whiteSpace:"nowrap"}}>
                <input type="file" className={"form-control input-sc-" + self.state.staff_certifications[k].id} style={{width: '120px', display: 'inline-block'}} />
                &nbsp;
                <button className="btn btn-primary" onClick={() => {self.editFile(self.state.staff_certifications[k].id)}}><i className="fa fa-fw fa-save"></i></button>
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Adicionar certificado</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Certificado:</label>
        <Select
          className="form-field-name"
          name="certification_id"
          value={this.state.certification_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChangeCertification.bind(this, 'certification_id')}
          options={this.state.certifications_list}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Data de início:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Local:</label>
        <Select
          className="form-field-name"
          name="certification_supplier_id"
          value={this.state.certification_supplier_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'certification_supplier_id')}
          options={this.state.certification_suppliers_list}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Data de término:</label>
        <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Nota:</label>
        <input type="text" className="form-control" name="result" value={this.state.result} onChange={this.handleChange.bind(this, 'result')} />
      </div>
      <div className="col-md-6 form-group">
        <label>Carga horária (em minutos):</label>
        <input type="text" className="form-control" name="pf" value={this.state.pf} onChange={this.handleChange.bind(this, 'pf')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data de expiração:</label>
        <InputMask value={this.state.expire}  maskChar={null} name="expire" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Gerar designações?:</label>
        <Select
          className="form-field-name"
          name="designacoes"
          value={this.state.designacoes}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'designacoes')}
          options={this.state.simple_list}
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Ministrou o curso?:</label>
        <Select
          className="form-field-name"
          name="type"
          value={this.state.type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'type')}
          options={this.state.simple_list}
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data de emissão:</label>
        <InputMask value={this.state.emissao}  maskChar={null} name="emissao" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'emissao')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar certificação</button>
  </form> */}
</div>
    );
  }
}

export default StaffCertificationsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffCertificationsTab.js